import { LocalStorageCache } from "@auth0/auth0-react";
import { borrarAlgunasCookies, borrarCookies, createCookie, readCookie } from "../Helpers/Cookies";

const getCallbackCookie = () => {
    const callbackCookie = readCookie('callbackCookie');

    return callbackCookie;
};

const setCallbackCookie = (callback) => {
    createCookie("callbackCookie", callback, 600);
    const callbackCookie = readCookie('callbackCookie');
    return callbackCookie != null;
};

const getAuth0Cookies = () => {
    let token = readCookie('token');
    let xvalue = readCookie('xvalue');
    if (token == null && xvalue == null) return null;
    return [token, xvalue]
};

const getAuth0RefreshToken = () => {
    const refresh_token = new LocalStorageCache;
    const key = refresh_token.allKeys().find(key => key.includes('auth0spa'));
    const refresh_token_value = refresh_token.get(key);
    const tokens = {};
    tokens.finalRefreshToken = refresh_token_value?.body?.refresh_token
    tokens.idToken = refresh_token_value?.body?.id_token
    tokens.userId = refresh_token_value?.body?.decodedToken.claims.sub;
    tokens.accessToken = refresh_token_value?.body?.access_token;
    return tokens;
};

const deleteAuth0Cookies = async () => {
    borrarCookies();
};

const deleteCallbackCookie = () => {
    borrarAlgunasCookies(['callbackCookie']);
};

const setOriginIdCookie = (sitioId) => {
    createCookie("OriginId", sitioId, 600);
    const OriginId = readCookie('OriginId');
    return OriginId != null;
};

export {
    getCallbackCookie,
    setCallbackCookie,
    getAuth0Cookies,
    deleteAuth0Cookies,
    getAuth0RefreshToken,
    deleteCallbackCookie,
    setOriginIdCookie
};